import { useEffect, useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import { AppBar, Box, Container, CssBaseline, Toolbar, useMediaQuery } from '@mui/material';
import Header from './Header';
import HorizontalBar from './HorizontalBar';
import LAYOUT_CONST from 'constant';
import useConfig from 'hooks/useConfig';
import { openDrawer } from 'store/slices/menu';
import { useDispatch } from 'store';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import useAuth from 'hooks/useAuth';
import LoadingLayout from './LoadingLayout';
import useTerms from 'hooks/useTerms';

const MainLayout = () => {
    const theme = useTheme();

    const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));

    const dispatch = useDispatch();
    const { layout, ready } = useConfig();
    const { isReady } = useAuth();
    const terms = useTerms();

    useEffect(() => {
        dispatch(openDrawer(true));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [matchDownMd]);

    const condition = layout === LAYOUT_CONST.HORIZONTAL_LAYOUT && !matchDownMd;

    const header = useMemo(
        () => (
            <Toolbar sx={{ p: condition ? '10px' : { xs: '0px', sm: '16px' } }}>
                <Header />
            </Toolbar>
        ),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [layout, matchDownMd]
    );
    if (!(isReady && ready)) return <LoadingLayout />;
    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar enableColorOnDark position="fixed" color="inherit" elevation={0} sx={{ bgcolor: 'transparent' }}>
                {header}
            </AppBar>
            {layout === LAYOUT_CONST.HORIZONTAL_LAYOUT && !matchDownMd && <HorizontalBar />}
            <Container
                sx={{
                    maxWidth: '1340px !important',
                    width: '100%',
                    margin: '0 auto',
                    mt: { xs: 12, md: 14 },
                    mb: { xs: 16, md: 3 },
                    display: 'flex'
                }}
            >
                {(layout === LAYOUT_CONST.VERTICAL_LAYOUT || matchDownMd) && <Sidebar />}
                {terms || <Outlet />}
            </Container>
        </Box>
    );
};

export default MainLayout;
